import { isPlainObject } from "@reduxjs/toolkit"

// Offline saves contain section patches, just like the server's site-data API.
// Merge nested objects; arrays and explicit empty/null values replace old values.
export function mergeSiteData(existing, changes) {
  const merged = { ...(isPlainObject(existing) ? existing : {}) }
  for (const [key, value] of Object.entries(changes || {})) {
    if (["__proto__", "constructor", "prototype"].includes(key)) continue
    merged[key] = isPlainObject(value) ? mergeSiteData(merged[key], value) : value
  }
  return merged
}
